module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Tilt-beam chain name","name":"Name","hint":"Enter a unique name.","btnCancel":"Back","btnSave":"Save"},"it":{"title":"Nome catena Tilt-beam","name":"Nome","hint":"Inserisci un nome univoco","btnCancel":"Annulla","btnSave":"Salva"}}')
  delete Component.options._Ctor
}
